import { OrderNotifications } from './OrderNotifications'

import './styles.modules.scss'

export default OrderNotifications
